import { HTTP_TOKEN_REPORT } from "./http";

export const getSales = (params) => {
  return HTTP_TOKEN_REPORT.get("jorney-sale", { params }).then((result) => {
    return result.data;
  });
};

export const getLeads = (params) => {
  return HTTP_TOKEN_REPORT.get("jorney-lead", { params }).then((result) => {
    return result.data;
  });
};



export const getConversation = (params) => {
  return HTTP_TOKEN_REPORT.get("jorney-whats", { params }).then((result) => {
    return result.data;
  });
};



